$bog_ui_app_sidebar $mol_page
	title \Sidebar
	body /
		<= Description $mol_view
			sub /
				<= description \Navigation sidebar with 3 display modes: dock (full width with labels), rail (icons only), and hidden (collapsed).
		<= Mode_title $mol_view
			sub /
				<= mode_title \Mode Switching
		<= Mode_buttons $mol_view
			sub /
				<= Dock_button $mol_button_minor
					click? <=> set_dock? null
					sub /
						<= dock_label \Dock
				<= Rail_button $mol_button_minor
					click? <=> set_rail? null
					sub /
						<= rail_label \Rail
				<= Hidden_button $mol_button_minor
					click? <=> set_hidden? null
					sub /
						<= hidden_label \Hidden
		<= Current_mode $mol_view
			sub /
				<= current_mode_text \Current mode: dock
		<= Preview $mol_view
			sub /
				<= Preview_sidebar $bog_ui_sidebar
					mode? <=> preview_mode? \dock
					items /
						<= Preview_item_home $bog_ui_sidebar_item
							Icon <= Preview_icon_home $mol_icon_home
							label \Home
						<= Preview_item_users $bog_ui_sidebar_item
							Icon <= Preview_icon_users $mol_icon_account
							label \Users
						<= Preview_item_settings $bog_ui_sidebar_item
							Icon <= Preview_icon_settings $mol_icon_cog
							label \Settings
				<= Preview_content $mol_view
					sub /
						<= preview_content_text \Main content area
